import React from 'react';
import {EmployeeNameWithAvatar} from 'components';
import {PayRate, PreviousManager, Manager} from './edit/components/table_components';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';

const columnsForField = (field, readOnly) => {
  switch (field) {
    case 'pay_rate':
      return [
        {
          header: 'mass_updates.edit.Old Pay Rate',
          attribute: 'previousPayRate',
          width: 1
        },
        {
          header: 'mass_updates.edit.New Pay Rate',
          component: PayRate,
          width: 2,
          sortBy: readOnly ? 'newPayRate' : null
        },
        {
          header: 'mass_updates.edit.Pay Type',
          render: (model => <FormattedMessage
            id='mass_updates.edit.pay_type'
            values={{unit: model.payRateUnit}}
          />),
          sortBy: 'payType',
          width: 1
        },
        {
          header: 'mass_updates.edit.Pay Currency',
          attribute: 'payRateCurrency',
          width: 1
        }
      ];
    case 'manager':
      return [
        {
          header: 'mass_updates.edit.Old Manager',
          component: PreviousManager,
          width: 2
        },
        {
          header: 'mass_updates.edit.Manager',
          component: Manager,
          width: 3
        }
      ];
    default:
      throw new Error('Unrecognized field in mass salary update');
  }
};

const adjustWidths = (columns, readOnly) => {
  let totalWidth = _.sumBy(columns, 'width');

  const targetWidth = readOnly ? 12 : 11;

  let i = 0;
  while (totalWidth !== targetWidth) {
    totalWidth = _.sumBy(columns, 'width');
    const column = columns[i];
    if (totalWidth < targetWidth) {
      column.width += 1;
    } else if (totalWidth > targetWidth) {
      column.width = Math.max(1, column.width - 1);
    }
    i++;
    if (i >= columns.length) {
      i = 0;
    }
  }
};

const getColumns = (massUpdate) => {
  const columns = [
    {
      header: 'mass_updates.edit.Employee',
      render: (model => <EmployeeNameWithAvatar href={`/employees/${model.employee.id}/`} employee={model.employee} size='sm'/>),
      width: 3,
      sortBy: 'employeeName'
    }
  ];

  massUpdate.includedFields.sort().forEach(field => {
    columns.push(...columnsForField(field, massUpdate.readOnly));
  });

  if (massUpdate.readOnly) {
    columns.push(
      {
        header: 'mass_updates.edit.Error Message',
        attribute: 'errorMessage',
        width: 3
      }
    );
  }

  adjustWidths(columns, massUpdate.readOnly);

  return columns;
};

export default getColumns;
